var _rect, _rect2, _circle, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAvatarLineLightswitch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 299 49"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 199.5,
    y: 1.725,
    width: 98,
    height: 45,
    rx: 22.5,
    fill: "#0E1932",
    stroke: "#3C5475",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.556,
    y: 10.225,
    width: 287,
    height: 27,
    rx: 13.5,
    fill: "url(#avatar-line-lightswitch_svg__paint0_linear)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 274,
    cy: 24.225,
    r: 13,
    fill: "#80AFE5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "avatar-line-lightswitch_svg__paint0_linear",
    x1: 0,
    y1: 37.225,
    x2: 287,
    y2: 37.225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#081122",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#435E83"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjk5IiBoZWlnaHQ9IjQ5IiB2aWV3Qm94PSIwIDAgMjk5IDQ5IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cmVjdCB4PSIxOTkuNSIgeT0iMS43MjUwMSIgd2lkdGg9Ijk4IiBoZWlnaHQ9IjQ1IiByeD0iMjIuNSIgZmlsbD0iIzBFMTkzMiIgc3Ryb2tlPSIjM0M1NDc1IiBzdHJva2Utd2lkdGg9IjMiLz4KPHJlY3Qgb3BhY2l0eT0iMC41NTU1OTQiIHk9IjEwLjIyNSIgd2lkdGg9IjI4NyIgaGVpZ2h0PSIyNyIgcng9IjEzLjUiIGZpbGw9InVybCgjcGFpbnQwX2xpbmVhcikiLz4KPGNpcmNsZSBjeD0iMjc0IiBjeT0iMjQuMjI1IiByPSIxMyIgZmlsbD0iIzgwQUZFNSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyIiB4MT0iMCIgeTE9IjM3LjIyNSIgeDI9IjI4NyIgeTI9IjM3LjIyNSIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjMDgxMTIyIiBzdG9wLW9wYWNpdHk9IjAuMDEiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjNDM1RTgzIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgAvatarLineLightswitch as ReactComponent };